var map = {
	"./AvenirNextLTPro-MediumCn.ttf": 457,
	"./DINNextLTW23-Bold.ttf": 458,
	"./Heebo-Medium.ttf": 459,
	"./SFProText-Regular.ttf": 460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;